import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getSession } from "./auth";

// Gates the Document Verification screens behind a session obtained via
// /document-verification/login. Nothing else on the site is affected.
const RequireDocVerificationAuth: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const location = useLocation();
  const session = getSession();

  if (!session) {
    return <Navigate to="/document-verification/login" state={{ from: location }} replace />;
  }

  return children;
};

export default RequireDocVerificationAuth;
